import { useNavigate } from 'react-router-dom';
import { useCreateSport, useTranslation } from '@/hooks';
import { CreateSportRequest } from '@/types/model';
import SportsForm from '@/components/forms/SportsForm';
import Button from '@/components/ui/Button.tsx';

const CreateSport = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const createSportMutation = useCreateSport();

  const handleSubmit = async (data: CreateSportRequest) => {
    try {
      const result = await createSportMutation.mutateAsync(data);
      if (result.success) {
        // Navigate to the sports list page after successful creation
        navigate('/content/sports', {
          state: { message: t.sports.messages.created }
        });
      }
    } catch (error) {
      console.error('Error creating sport:', error);
      throw error; // Re-throw to let the form handle the error display
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-4">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <Button
          onClick={handleCancel}
          variant="link"
        >
          ← Volver a la lista
        </Button>
        <SportsForm
          onSuccess={handleSubmit}
          onCancel={handleCancel}
          isSubmitting={createSportMutation.isPending}
        />
      </div>
    </div>
  );
};

export default CreateSport;
